import * as React from 'react'
import { Grid2, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@mui/material';
import { useTheme } from '@emotion/react';

import Navbar from '../../Setup/Navbar'
import HeadingTest from '../../../BuiltInComponent/HeadingTest'
import { getDeepDetailsData } from '../../../features/Clients/reports/trackingSlice'
import { useDispatch, useSelector } from 'react-redux'
import dayjs from 'dayjs';

export default function TrackingViewDetails() {
    const dispatch = useDispatch()

    const { tdd, totals } = useSelector(state => state.trck)
    const { user } = useSelector(state => state.auth)

    React.useEffect(() => {
        dispatch(getDeepDetailsData())
    }, [dispatch])

    const tableColumns = [
        { fieldName: 'mhName', cName: 'Row Labels', status: 'en', textAlign: 'center', dType: 'string' },
        { fieldName: 'shipLineName', cName: 'Shipping Line', status: 'en', textAlign: 'center', dType: 'string' },
        { fieldName: 'contNo', cName: 'Container No', status: 'en', textAlign: 'center', dType: 'string' },
        { fieldName: 'sailDate', cName: 'Sailing Date', status: 'en', textAlign: 'center', dType: 'date' },
        { fieldName: 'arrivalDate', cName: 'Arrival Date', status: 'en', textAlign: 'center', dType: 'date' },
        { fieldName: 'amount', cName: 'Inv Amount', status: 'en', textAlign: 'right', dType: 'number' },
        ...(user.userName === 'irfan' ? [{ fieldName: 'portName', cName: 'Port Name', status: 'en', textAlign: 'left', dType: 'string' }] : [])
    ]
    return (
        <>
            <Navbar />
            <Grid2 container spacing={2}>
                <Grid2 size={4}></Grid2>
                <Grid2 size={4}>
                    <HeadingTest text={'Tracking Details'} />
                </Grid2>
                <Grid2 size={4}></Grid2>
                <Grid2 size={2}></Grid2>
                <Grid2 size={8}>
                    <StickyHeadTable tableColumns={tableColumns} tableData={tdd} totals={totals} perPage={50} />
                </Grid2>
                <Grid2 size={2}></Grid2>
            </Grid2>
        </>
    )
}

function StickyHeadTable(props) {

    const theme = useTheme()

    const perPage = props.perPage
    const tableColumns = props.tableColumns
    const rows = props.tableData

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(perPage || 50);
    // const [filter, setFilter] = React.useState(''); // New state for filtering
    const [filteredRows, setFilteredRows] = React.useState(rows); // New state to hold filtered data

    // Handle pagination
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    // Handle the filter input change
    // const handleFilterChange = (event) => {
    //     const filterValue = event.target.value.toLowerCase();
    //     // setFilter(filterValue);

    //     // Filter rows based on filter input
    //     const filteredData = rows.filter(row => {
    //         return tableColumns.some(col => {
    //             const cellValue = row[col.fieldName]?.toString().toLowerCase();
    //             return cellValue && cellValue.includes(filterValue);
    //         });
    //     });

    //     setFilteredRows(filteredData);
    // };

    React.useEffect(() => {
        setFilteredRows(rows); // Update filteredRows if rows change
        console.log(tableColumns.length)
    }, [rows]);

    return (
        <Paper sx={{ width: '98%', overflow: 'hidden', backgroundColor: 'rgb(250, 250, 250)' }}>
            {/* <Grid2 container spacing={1}>
                <Grid2 size={4}></Grid2>
                <Grid2 size={4}>
                    <TextField
                        sx={{ margin: '20px' }}
                        label="Filter"
                        variant="outlined"
                        fullWidth
                        value={filter}
                        onChange={handleFilterChange}
                        placeholder="Search by any column..."
                        size='small'
                    />
                </Grid2>
                <Grid2 size={4}></Grid2>
            </Grid2> */}
            <TableContainer >
                <Table stickyHeader aria-label="sticky table" size='small'>
                    <TableHead>
                        <TableRow>
                            {tableColumns && tableColumns.map((columns, index) => (
                                tableColumns[index].status === 'en' ? (
                                    <TableCell
                                        key={columns.cName || index}
                                        style={{
                                            backgroundColor: theme.palette.primary.main,
                                            color: 'white',
                                            textAlign: `${tableColumns[index].textAlign}`,
                                            fontWeight: 'bolder',
                                            width: `${columns.width}`,
                                            textShadow: 'black 2px 2px 4px',
                                            whiteSpace: 'nowrap'
                                        }}
                                    >
                                        {columns.cName}
                                    </TableCell>
                                ) : null
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredRows && filteredRows
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row, rowIndex) => {
                                return (
                                    <TableRow
                                        key={rowIndex}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        style={{ width: '70%', }}
                                    >
                                        {tableColumns.map((col, index) => (
                                            <TableCell
                                                key={tableColumns[index].fieldName || index}
                                                style={{
                                                    textAlign: `${tableColumns[index].dType === 'number' ?
                                                        index === 0 ? 'center' : 'right' : 'left'}`,
                                                    fontSize: rowIndex === rows.length - 1 ? 15 : 13,
                                                    width: tableColumns[index].width,
                                                    cursor: index === 0 ? 'pointer' : '',
                                                }}
                                                component="th"
                                                scope="row"
                                                sx={{
                                                    border: 'ridge 1px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                {tableColumns[index].dType === 'number'
                                                    ? Math.round(row[tableColumns[index].fieldName]).toLocaleString("en-US")
                                                    : tableColumns[index].dType === 'date' ? dayjs(row[tableColumns[index].fieldName]).format('DD-MMM-YY') : row[tableColumns[index].fieldName]}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[50, 100, 200]}
                component="div"
                count={filteredRows?.length || 0}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    );
}